
import XDialog from 'vux/src/components/x-dialog/index.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'

export default {
name: "myVideo",
components: {
XDialog,
InlineLoading
},
props: {
videoUrl: String,
},
data() {
return {
activeUrl: this.videoUrl,
showHideOnBlur: true,
loaded:false
};
},
mounted() {
console.log("myvideo mouted");

this.$refs.videoPlayer.load()
this.$refs.videoPlayer.addEventListener('canplay',()=>{
console.log('player can play')
this.loaded=true

this.$refs.videoPlayer.play()
})
this.$refs.videoPlayer.addEventListener('webkitendfullscreen',()=>{
this.$emit("onHideMyVideo");
})
this.$refs.videoPlayer.addEventListener('x5videoexitfullscreen',()=>{

this.$emit("onHideMyVideo");
})
},
beforeDestroy() {},
methods: {
onHide() {
console.log("隐藏视频窗口");
this.$emit("onHideMyVideo");
},
screenChange(){

}
},
watch: {
videoUrl(url) {
this.activeUrl = url;
},
},
};



// WEBPACK FOOTER //
// ./src/myComponents/myVideo/myVideo.vue